import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router, RouterModule, } from '@angular/router';
import { StaticSourceDirective } from 'src/app/directives/static-src.directive';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { UserAppService } from 'src/app/services/user-app.service';
import { ShowDialogsComponent } from '../show-dialogs/show-dialogs.component';
import { MatDialog } from '@angular/material/dialog';
import { filter, Subscription } from 'rxjs';
import { NamingSizePipe } from 'src/app/pipes/naming-size.pipe';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [
    MaterialModule,
    RouterModule,
    StaticSourceDirective,
    NamingSizePipe,
  ],
  template: `
    <aside class="rail" [class.collapsed]="collapsed" *ngIf="!isSalesRepOnly">
      <!-- brand + collapse toggle -->
      <div class="brow">
        <div
          class="brand"
          *ngIf="!collapsed"
          [routerLink]="routingLink.home"
          (click)="activateMenuFromRoute()"
        >
          <img [src]="navbarLogoUrl" alt="Logo" class="brand-logo" appStaticSrc />
        </div>
        <div
          class="brand mini"
          *ngIf="collapsed"
          [routerLink]="routingLink.home"
          (click)="activateMenuFromRoute()"
        >
          <img [src]="navbarIconUrl" alt="Logo" class="brand-logo" appStaticSrc />
        </div>
        <button
          type="button"
          class="toggle-btn"
          (click)="toggleCollapsed()"
          [matTooltip]="collapsed ? 'Expand' : 'Collapse'"
          matTooltipPosition="right"
        >
          <span class="material-icons">{{
            collapsed ? 'chevron_right' : 'chevron_left'
          }}</span>
        </button>
      </div>

      <!-- primary nav -->
      <nav class="nav" *ngIf="!notLoggedInStatus">
        <a
          class="item"
          [class.active]="activeMenu['emplay'] || activeMenu['customer']"
          [routerLink]="routingLink.home"
          (click)="activateMenuFromRoute()"
          [matTooltip]="collapsed ? 'Home' : ''"
          matTooltipPosition="right"
        >
          <span class="ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /></svg>
          </span>
          <span class="lbl" *ngIf="!collapsed">Home</span>
        </a>

        <a
          class="item"
          *ngIf="hasAccess('dataSource')"
          [class.active]="activeMenu['data_management']"
          [routerLink]="routingLink.dataSource"
          (click)="activateMenuFromRoute()"
          [matTooltip]="collapsed ? 'Data Sources' : ''"
          matTooltipPosition="right"
        >
          <span class="ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="5.5" rx="7" ry="3" /><path d="M5 5.5v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" /><path d="M5 11.5v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" /></svg>
          </span>
          <span class="lbl" *ngIf="!collapsed">Data Sources</span>
        </a>

        <a
          class="item"
          *ngIf="hasAccess('mySolution')"
          [class.active]="activeMenu['manage-solutions']"
          [routerLink]="routingLink.mySolution"
          (click)="activateMenuFromRoute()"
          [matTooltip]="collapsed ? 'My Solutions' : ''"
          matTooltipPosition="right"
        >
          <span class="ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>
          </span>
          <span class="lbl" *ngIf="!collapsed">My Solutions</span>
        </a>

        <a
          class="item"
          *ngIf="hasAccess('marketplaceManager')"
          [class.active]="activeMenu['solutions-manager']"
          [routerLink]="routingLink.marketplaceManager"
          (click)="activateMenuFromRoute()"
          [matTooltip]="collapsed ? 'Manage Marketplace' : ''"
          matTooltipPosition="right"
        >
          <span class="ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9" /><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" /><path d="M3 9h18" /></svg>
          </span>
          <span class="lbl" *ngIf="!collapsed">Manage Marketplace</span>
        </a>

        <a
          class="item"
          *ngIf="hasAccess('marketplace')"
          [class.active]="activeMenu['marketplace']"
          [routerLink]="routingLink.marketPlace"
          (click)="activateMenuFromRoute()"
          [matTooltip]="collapsed ? 'Marketplace' : ''"
          matTooltipPosition="right"
        >
          <span class="ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9" /><path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" /><path d="M9 20v-6h6v6" /></svg>
          </span>
          <span class="lbl" *ngIf="!collapsed">Marketplace</span>
        </a>
      </nav>

      <!-- documentation (above Settings, visible to all roles) -->
      <nav class="nav" *ngIf="!notLoggedInStatus">
        <a
          class="item"
          *ngIf="hasAccess('help')"
          [class.active]="activeMenu['documentation']"
          [routerLink]="routingLink.help"
          (click)="activateMenuFromRoute()"
          [matTooltip]="collapsed ? 'Documentation' : ''"
          matTooltipPosition="right"
        >
          <span class="ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4.5A1.5 1.5 0 0 1 5.5 3H20v16H5.5A1.5 1.5 0 0 0 4 20.5z"/><path d="M4 20.5A1.5 1.5 0 0 1 5.5 19H20"/></svg>
          </span>
          <span class="lbl" *ngIf="!collapsed">Documentation</span>
        </a>
      </nav>

      <!-- settings: expandable when open, flyout when collapsed -->
      <ng-container *ngIf="!notLoggedInStatus">
        <div class="settings-block" *ngIf="!collapsed">
          <div
            class="grp-h"
            [class.active]="activeMenu['settings']"
            (click)="settingsOpen = !settingsOpen"
          >
            <span class="ico">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 0 0-2-1.2L14 2h-4l-.5 2.6a7 7 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6A7 7 0 0 0 5 12a7 7 0 0 0 .1 1.2l-2 1.6 2 3.4 2.4-1a7 7 0 0 0 2 1.2L10 22h4l.5-2.6a7 7 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6A7 7 0 0 0 19 12Z" /></svg>
            </span>
            <span class="lbl">Settings</span>
            <span class="chev" [class.open]="settingsOpen">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6" /></svg>
            </span>
          </div>

          <div class="sub" *ngIf="settingsOpen">
            <a *ngIf="hasAccess('dataConnection')" routerLinkActive="active" [routerLink]="routingLink.dataConnection" (click)="activateMenuFromRoute()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2v6M15 2v6M7 8h10v3a5 5 0 0 1-10 0z" /><path d="M12 16v6" /></svg>
              <span>Data Connections</span>
            </a>
            <a *ngIf="hasAccess('sso')" routerLinkActive="active" [routerLink]="routingLink.sso" (click)="activateMenuFromRoute()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" /></svg>
              <span>Configure SAML</span>
            </a>
            <a *ngIf="hasAccess('users')" routerLinkActive="active" [routerLink]="routingLink.users" (click)="activateMenuFromRoute()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3" /><path d="M2 21c0-3.5 3-6 7-6s7 2.5 7 6" /><path d="M17 8a3 3 0 0 1 0 6M22 21c0-2.5-1.3-4.4-3.5-5.3" /></svg>
              <span>User Management</span>
            </a>
            <a *ngIf="hasAccess('webChat')" routerLinkActive="active" [routerLink]="routingLink.webChat" (click)="activateMenuFromRoute()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
              <span>Web-Chat</span>
            </a>
            <a *ngIf="hasAccess('customerHomepage')" routerLinkActive="active" [routerLink]="routingLink.customerHomepage" (click)="activateMenuFromRoute()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /></svg>
              <span>Customer Homepage</span>
            </a>
            <a *ngIf="hasAccess('tasks')" routerLinkActive="active" [routerLink]="routingLink.tasks" (click)="activateMenuFromRoute()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" /></svg>
              <span>Tasks</span>
            </a>
          </div>
        </div>

        <div class="settings-collapsed" *ngIf="collapsed">
          <a
            class="item"
            [class.active]="activeMenu['settings']"
            [matMenuTriggerFor]="settingsMenu"
            matTooltip="Settings"
            matTooltipPosition="right"
          >
            <span class="ico">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 0 0-2-1.2L14 2h-4l-.5 2.6a7 7 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6A7 7 0 0 0 5 12a7 7 0 0 0 .1 1.2l-2 1.6 2 3.4 2.4-1a7 7 0 0 0 2 1.2L10 22h4l.5-2.6a7 7 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6A7 7 0 0 0 19 12Z" /></svg>
            </span>
          </a>
        </div>

        <mat-menu #settingsMenu="matMenu" class="d2c-menu">
          <button mat-menu-item [routerLink]="routingLink.dataConnection" *ngIf="hasAccess('dataConnection')">Data Connections</button>
          <button mat-menu-item [routerLink]="routingLink.sso" *ngIf="hasAccess('sso')">Configure SAML</button>
          <button mat-menu-item [routerLink]="routingLink.users" *ngIf="hasAccess('users')">User Management</button>
          <button mat-menu-item [routerLink]="routingLink.webChat" *ngIf="hasAccess('webChat')">Web-Chat</button>
          <button mat-menu-item [routerLink]="routingLink.customerHomepage" *ngIf="hasAccess('customerHomepage')">Customer Homepage</button>
          <button mat-menu-item [routerLink]="routingLink.tasks" *ngIf="hasAccess('tasks')">Tasks</button>
        </mat-menu>
      </ng-container>

      <div class="spacer"></div>

      <!-- account (pinned bottom) -->
      <div
        class="acct"
        *ngIf="!notLoggedInStatus"
        [matMenuTriggerFor]="users"
        [matTooltip]="collapsed ? userName : ''"
        matTooltipPosition="right"
      >
        <span class="av">{{ initials }}</span>
        <span class="nm" *ngIf="!collapsed">{{ userName | namingsize : 22 }}</span>
        <span class="caret material-icons" *ngIf="!collapsed">expand_more</span>
      </div>
      <mat-menu #users="matMenu" class="user-menu-panel">
        <div class="flex flex-col min-w-[200px]">
          <button mat-menu-item (click)="logout()">Log Out</button>
          <div class="px-4 py-2 text-left text-sm text-gray-600 border-t border-gray-200 mt-auto">
            <span class="truncate block max-w-[200px]">{{ userName | namingsize : 20 }}</span>
          </div>
        </div>
      </mat-menu>
    </aside>
  `,
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit {
  navbarLogoUrl: string =
    environment.navbarLogoImageUrl || 'assets/images/zinger-logo.png';
  navbarIconUrl: string =
    (environment as any).navbarIconImageUrl || 'assets/images/zinger-icon.png';
  userRoles: any = []
  imageLoadError = false;
  activeMenu: { [k: string]: boolean } = {
    emplay: true,
    data_management: false,
    'manage-solutions': false,
    settings: false,
    documentation: false,
    marketplace: false,
    'solutions-manager': false,
  };
  sidenav: boolean = false;
  collapsed: boolean = false;
  settingsOpen: boolean = false;
  @Output() dataEmitter = new EventEmitter<boolean>();
  requiredRolesForMenu: any = {
    home: [],
    dataSource: ['emplay_consultant', 'customer_consultant'],
    mySolution: ['emplay_consultant', 'customer_consultant'],
    dataConnection: ['emplay_consultant', 'customer_consultant'],
    marketplaceManager: ['solution_manager'],
    marketplace: ['customer_consultant'],
    help: [],
    sso: ['admin', 'solution_manager'],
    users: ['admin', 'solution_manager'],
    webChat: ['solution_manager'],
    customerHomepage: ['solution_manager'],
    tasks: ['emplay_consultant', 'customer_consultant'],
  };
  notLoggedInStatus: boolean = false;
  currentRoute: string = '';
  routingLink = {
    home: '/',
    dataSource: '/home/data_management/data_sources',
    mySolution: '/home/manage-solutions/mySolutions',
    marketplaceManager: '/home/solutions-manager/marketplace',
    marketPlace: '/home/customer/available-solutions',
    dataConnection: '/home/settings/data_connection/',
    help: '/home/settings/documentation',
    sso: '/home/settings/saml-login/',
    users: '/home/settings/manage-users',
    webChat: '/home/solutions-manager/webchat',
    customerHomepage: '/home/solutions-manager/customer-homepage',
    tasks: '/home/settings/tasks',
  };

  userName: string = '';
  routerEventsSubscription: Subscription | any;

  get isSalesRepOnly(): boolean {
    return (
      Array.isArray(this.userRoles) &&
      this.userRoles.length === 1 &&
      this.userRoles.includes('sales_rep')
    );
  }

  get initials(): string {
    const parts = (this.userName || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  constructor(
    private router: Router,
    private snackBar: SharedFeaturesService,
    private userServices: UserAppService,
    private dialog: MatDialog
  ) {
    this.activateMenuFromRoute();
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
    this.dataEmitter.emit(this.collapsed);
    localStorage.setItem('sidebarCollapsed', String(this.collapsed));
  }

  // Angular does not await ngOnInit, so an async hook turns any rejection
  // inside it into an unhandled promise rejection (Sonar typescript:S6544).
  // The hook stays void and the awaited work is handled here.
  ngOnInit(): void {
    void this.loadUserContext().catch(err =>
      console.error('SideNavComponent could not load the user context', err));
  }

  private async loadUserContext() {
    this.collapsed = localStorage.getItem('sidebarCollapsed') === 'true';
    this.dataEmitter.emit(this.collapsed);
    const jsonData: any = await this.userServices.loginStatus();
    this.userRoles = jsonData['groups'];
    this.resolveUserName(jsonData);
    if (!('username' in jsonData)) this.notLoggedInStatus = true;
    if (jsonData['groups'].includes('customer_consultant')) {
      this.routingLink.mySolution = '/home/customer/manage-solutions';
      this.routingLink.home = '/home/customer';
    }
  }

  hasAccess(menuItem: string): boolean {
    const allowedRoles = this.requiredRolesForMenu[menuItem] || [];
    if (allowedRoles.length === 0) {
      return true;
    }
    return this.userRoles.some((role: string) => allowedRoles.includes(role));
  }


  activateMenuFromRoute() {
    this.fetchActiveMenu(this.router.url);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const currentUrl = this.router.url;
        this.fetchActiveMenu(currentUrl);
      });
  }

  resolveUserName(userData: any) {
    if (userData['first_name'] != '')
      this.userName = userData['first_name'] + ' ' + userData['last_name'];
    else this.userName = userData['username'];
  }

  activateMenu(menu: string) {
    menu = menu.split('/')[0];
    this.activeMenu = Object.fromEntries(
      Object.keys(this.activeMenu).map((key) => [key, false])
    );
    if (menu === 'customer' || menu === '') menu = 'emplay';
    if (menu === 'available-solutions' || menu === 'marketplace')
      menu = 'marketplace';

    this.activeMenu[menu] = true;
  }


  logout() {
    const versionDialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Log out?',
        message: 'You will be signed out of your account.',
        confirmText: 'Log out',
        cancelText: 'Cancel',
      },
      disableClose: false,
    });
    versionDialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.userServices.logout().subscribe({
          next: (response: any) => {
            this.snackBar.openSnackBar(
              response?.message || 'Logged out successfully.',
              'Close',
              'success-snackbar'
            );

            this.router.navigateByUrl('/account');
          },
          error: (error) => {
            if (error?.status === 401 || error?.status === 403) {
              this.snackBar.openSnackBar(
                'Logged out successfully.',
                'Close',
                'success-snackbar'
              );
              this.router.navigateByUrl('/account');
            } else {
              this.snackBar.openSnackBar(
                error?.error?.message || error?.message || 'Logout failed',
                'Close',
                'error-snackbar'
              );
            }
          },
        });
      }
    });
  }

  fetchActiveMenu(url: string) {
    if (url.includes('settings/documentation')) {
      // Documentation lives under /home/settings/ but has its own nav item —
      // don't let the generic settings branch claim it.
      this.activateMenu('documentation');
    } else if (url.includes('settings')) {
      this.activateMenu('settings');
      this.settingsOpen = true;
    } else if (url.includes('data_management'))
      this.activateMenu('data_management');
    else if (url.includes('manage-solutions'))
      this.activateMenu('manage-solutions');
    else if (url.includes('available-solutions'))
      this.activateMenu('marketplace');
    else if (url.includes('marketplace'))
      this.activateMenu('solutions-manager');
    else if (url.includes('customer')) this.activateMenu('customer');
  }
}
